import React from 'react';
import './Screen.css';
import HistoryDisplay from './HistoryDisplay';

function SummaryScreen({ history = [], variables = {}, onRestart, onNextPhrase, viewingPhraseIndex = 0, onPhraseSelect }) {
  return (
    <div className="summary-screen">
      <div className="summary-content">
        <h2 className="summary-title">Ваша подготовка к конфликту</h2>
        
        <div className="summary-history">
          <HistoryDisplay 
            history={history} 
            variables={variables} 
            viewingPhraseIndex={viewingPhraseIndex}
            onPhraseSelect={onPhraseSelect}
          />
        </div>

        <div className="summary-buttons">
          {onNextPhrase && (
            <button className="button next-phrase-button" onClick={onNextPhrase}>
              Следующая фраза
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SummaryScreen;

